<template>
  <v-layout>
    <v-edit-dialog
      v-if="!loading"
      persistent
      lazy
      large
      cancel-text="Отмена"
      save-text="Ок"
      width="500"
      @cancel="closeDialog"
      @open="openDialog"
      @save="save"
    >
      <div class="link">
        {{ transition.title }}
      </div>
      <TransitionSelect
        slot="input"
        v-model="transition"
        :transitions="transitions"
        class="my-2"
      />
    </v-edit-dialog>
    <v-progress-circular
      v-else
      indeterminate
      color="primary"
      size="20"
      width="2"
    />
  </v-layout>
</template>
<script>
import TransitionSelect from "../../../../components/selection-field/TransitionSelect.vue";
import * as shippingInWarehouseApi from "../../../../backend/shipping-in-warehouseApi.js";
import { warehouseStates } from "../warehouse-state.js";
export default {
  components: { TransitionSelect },
  props: ["value", "item", "column", "itemIndex"],
  data() {
    return {
      transition: null,
      transitions: null,
      loading: false,
    };
  },
  computed: {
    warehouseStates() {
      return warehouseStates;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.setTransition(value);
      },
      immediate: true,
    },
  },
  methods: {
    setTransition(value) {
      this.transition = this.warehouseStates.find((s) => s.id === value);
    },
    async getTransitions() {
      this.transitions = await shippingInWarehouseApi.getTransitions(
        this.item.id,
      );
    },
    async save() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "warehouseDetails/changeWarehousePhaseState",
          {
            transition: this.transition,
            phaseId: this.item.id,
            columnName: this.column.name,
          },
        );
        this.loading = false;
        this.closeDialog();
        this.showInfo("Изменения сохранены");
      } catch (error) {
        this.setTransition(this.value);
        this.loading = false;
        throw error;
      }
    },
    openDialog() {
      this.getTransitions();
      this.$emit("openEditDialog", this.itemIndex);
    },
    closeDialog() {
      this.setTransition(this.value);
      this.$emit("openEditDialog", null);
    },
  },
};
</script>